// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-tieredmenu-root-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0;
}

.p-tieredmenu-overlay {
  background-color: white;
  margin-top: 8px;
  border-radius: 6px;
  box-shadow: var(--shadow-high);
}

.p-menuitem-text {
  color: var(--secondary-accent-text-color);
  font-size: 14px;
}

.p-menuitem-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 4px;

  &:hover {
    background-color: var(--light-background-color);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/toggle-actions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;;EAElB;IACE,+CAA+C;EACjD;AACF","sourcesContent":[".p-tieredmenu-root-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px 0;\n}\n\n.p-tieredmenu-overlay {\n  background-color: white;\n  margin-top: 8px;\n  border-radius: 6px;\n  box-shadow: var(--shadow-high);\n}\n\n.p-menuitem-text {\n  color: var(--secondary-accent-text-color);\n  font-size: 14px;\n}\n\n.p-menuitem-link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 4px;\n\n  &:hover {\n    background-color: var(--light-background-color);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
